<nbc-alert></nbc-alert>
<div *ngIf="gridData?.items?.length > 0" style="overflow-x: auto; overflow-y: hidden;">
  <div class="grid-table">
    <div class="hdr-grid-row grid-row">
      <div class="hdr-grid-col text-center grid-col-15">
      </div>

      <div class="hdr-grid-col psd text-center grid-col-60"
           [ngClass]="gridData.query.sortByColumn === 'positionStartDate'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="positionStartDate"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('positionStartDate')">
          Position <br />Start Date
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'positionStartDate'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col con text-center grid-col-125"
           [ngClass]="gridData.query.sortByColumn === 'contact'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="contact"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('contact')">
          Contact Name
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'contact'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col hm text-center grid-col-110"
           [ngClass]="gridData.query.sortByColumn === 'hiringManager'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="hiringManager"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('hiringManager')">
          Hiring Manager
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'hiringManager'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col pt text-center grid-col-85"
           [ngClass]="gridData.query.sortByColumn === 'registrationStatus'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="registrationStatus"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('registrationStatus')">
          Registration Status
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'registrationStatus'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col pt text-center grid-col-85"
           [ngClass]="gridData.query.sortByColumn === 'employeeType'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="employeeType"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('employeeType')">
          Employee Type
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'employeeType'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col hm text-center grid-col-110"
           [ngClass]="gridData.query.sortByColumn === 'proxyName'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="hiringManager"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('proxyName')">
          Proxy Name
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'proxyName'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col empty grid-col-20">
        &nbsp;
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col empty1 grid-col-20">
        &nbsp;
      </div>
      <div class="hdr-grid-col hm text-center grid-col-90"
        [ngClass]="gridData.query.sortByColumn === 'sso'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" data-sort-column-name="sso" class="sortable-column text-nowrap"
          style="text-transform:uppercase" (click)="sortOnColumn('sso')">
          SSO
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'sso'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>
      <div class="hdr-grid-col hm text-center grid-col-90"
        [ngClass]="gridData.query.sortByColumn === 'employmentStatus'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" data-sort-column-name="employmentStatus" class="sortable-column text-nowrap"
          style="text-transform:uppercase" (click)="sortOnColumn('employmentStatus')">
          Employee Status
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'employmentStatus'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>
      <div class="hdr-grid-col text-center grid-col-60"
           [ngClass]="gridData.query.sortByColumn === 'dateRequested'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" style="text-transform:uppercase"
           data-sort-column-name="dateRequested"
           class="sortable-column text-nowrap"
           (click)="sortOnColumn('dateRequested')">
          Date <br />Requested
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'dateRequested'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col text-center hdr-grid-col-hlight grid-col-120">
        Contact Type
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight grid-col-120">
        I9 Verify
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight sap grid-col-127">
        SAP Position #
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight grid-col-60">
        TAF Submitted
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight can grid-col-90">
        Cancel Request
      </div>
    </div>

    <!-- Grid Body -->
    <div *ngFor="let listItem of gridData.items; let index=index;"
         class="grid-row"
         id="row-{{listItem?.requestNumber}}"
         ng-attr-data-id="{{listItem?.requestNumber}}">

      <div title="{{listItem?.onboardngStatus}}"
           class="grid-col grid-col text-center grid-col-15 {{listItem?.requestStatusColor}}">
        <span>&nbsp;</span>
      </div>

      <div class="grid-col text-center grid-col-60">
        <span class="grid-dtl-text">
          {{listItem.positionStartDate | date:'MM/dd/yyyy'}}
        </span>
      </div>

      <div class="grid-col text-center grid-col-120">
        <a href="/scorepay/contact/{{listItem?.scoreId ? listItem.scoreId : 0}}"
           target="_blank"
           class="btn-link">
          {{listItem.contactName}}
        </a>
      </div>

      <div class="grid-col text-center grid-col-100">
        <span class="grid-dtl-text">{{listItem.hiringManager}}</span>
      </div>

      <div class="grid-col text-center grid-col-120">
        <span class="grid-dtl-text">{{listItem.registrationStatus}}</span>
      </div>

      <div class="grid-col text-center grid-col-80">
        <span class="grid-dtl-text" *ngIf="listItem.employeeType != null">
          {{listItem.employeeType}}
        </span>
      </div>

      <div class="grid-col text-center grid-col-100">
        <div *ngIf="listItem.proxyName != ''">
          <a href="/scorepay/contact/{{listItem?.proxyId ? listItem.proxyId : 0}}"
             target="_blank"
             class="btn-link">
            {{listItem.proxyName}}
          </a>
        </div>
        <div *ngIf="listItem.proxyName == ''">
          N/A
        </div>
      </div>

      <div class="open-position-modal-el grid-col text-center grid-col-lnk"
           style="background-color:#e6b800"
           data-request-no="{{listItem.requestNumber}}"
           data-crew-registration-no="{{listItem.registrationNo}}"
           (click)="openOnboardingModal(listItem)">
        <i class="fa fa-ellipsis-h"></i>
      </div>

      <ng-container *ngIf="hasTalentSu">
        <a href="javascript:void(0)"
           (click)="openEditPositionRequestModal(listItem)"
           class="open-position-modal-el grid-col text-center grid-col-lnk"
           style="background-color:#800080"
           data-request-no="{{listItem.requestNumber}}"
           data-crew-registration-no="{{listItem.registrationNo}}">
          <i class="fa fa-ellipsis-h"></i>
        </a>
      </ng-container>
      <div class="grid-col text-center grid-col-80">
        <span class="grid-dtl-text"  *ngIf="listItem.sso != null">
          {{listItem.sso}}
        </span>
      </div>
      <div class="grid-col text-center grid-col-80">
        <span class="grid-dtl-text" *ngIf="listItem.employmentStatus != null">
          {{listItem.employmentStatus}}
        </span>
      </div>
      <div class="grid-col text-center grid-col-60">
        <div class="tooltips">
          <span class="grid-dtl-text">
            {{ listItem.requestedDate | date:'MM/dd/yyyy' }}
          </span>
          <span class="tooltiptext text" *ngIf="listItem.requestNumber != ''">
            Request # {{listItem.requestNumber}}
          </span>
        </div>
      </div>

      <div class="grid-col text-center grid-col-80">
        <span class="grid-dtl-text">{{listItem.contactType}}</span>
      </div>

      <!-- I9 Verify column:
           Vendor    → read-only "N/A" text (same pattern as SAP Position # Vendor case)
           Non-Vendor → editable dropdown (N/A removed from options) -->
      <div *ngIf="hasTalentSu" class="grid-col grid-col-hlight text-center grid-col-90">

        <!-- Vendor: display read-only N/A -->
        <div *ngIf="listItem.isVendor">
          <span class="grid-dtl-text">N/A</span>
        </div>

        <!-- Non-Vendor: editable dropdown without N/A option -->
        <div *ngIf="!listItem.isVendor">
          <nbc-select name="I9Verify-{{listItem.registrationNo}}"
                      id="I9Verify-{{listItem.registrationNo}}"
                      [source]="i9VerifyList"
                      value="id"
                      display="description"
                      [(model)]="listItem.i9VerifyReason"
                      placeHolderDisplay="Select Reason"
                      placeHolderValue="0"
                      (modelChange)="updateI9VerifyDetails(listItem)">
          </nbc-select>
        </div>

      </div>

      <!-- SAP Position # column (unchanged) -->
      <div *ngIf="hasTalentSu" class="grid-col grid-col-hlight text-center grid-col-90">
        <div *ngIf="listItem.contactType == 'Vendor'">
          <span class="grid-dtl-text">N/A</span>
        </div>
        <div *ngIf="listItem.contactType == 'Non-Vendor'">
          <input type="text" style="width:110px"
                 maxlength="25"
                 class="update-reg"
                 data-request-no="{{listItem.requestNumber}}"
                 data-crew-registration-no="{{listItem.registrationNo}}"
                 data-column="SAP Position"
                 [value]="listItem.sapNo != null ? listItem.sapNo : ''"
                 [(ngModel)]="listItem.sapNo"
                 (change)="updateDetails(listItem)"
                 [disabled]="listItem.contactType == 'Vendor'" />
        </div>
      </div>

      <!-- TAF column: Vendor=N/A, Non-Vendor=checkbox enabled only at Onboarding InProgress+ -->
      <div *ngIf="hasTalentSu" class="grid-col grid-col-hlight text-center grid-col-60">
        <div *ngIf="listItem.isVendor">
          <span class="grid-dtl-text">N/A</span>
        </div>
        <div *ngIf="!listItem.isVendor">
          <input type="checkbox"
                 [(ngModel)]="listItem.isTafSubmitted"
                 [disabled]="!listItem.isTafSubmittedEnabled"
                 (change)="updateTafDetails(listItem)" />
        </div>
      </div>

      <div *ngIf="hasTalentSu" class="grid-col grid-col-hlight text-center grid-col-90">
        <button class="onboarding-button cancel-reg"
                data-request-no="{{listItem.requestNumber}}"
                data-crew-registration-no="{{listItem.crewRegistrationNo}}"
                (click)="cancel(listItem)">
          Cancel <i class="fa fa-close"></i>
        </button>
      </div>

    </div>
  </div>
</div>
